module.exports = {"360321101":"琴亭镇","360321102":"路口镇","360321103":"良坊镇","360321104":"升坊镇","360321105":"坊楼镇","360321200":"闪石乡","360321201":"湖上乡","360321202":"三板桥乡","360321203":"神泉乡","360321204":"六市乡","360321205":"高洲乡","360321206":"荷塘乡","360321207":"南岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360321.json
// module id = 1164
// module chunks = 0